<template>
    <section class="visual-section visual-section--category">
        <div class="section-header mobile-none">
            <p class="section-title">카테고리</p>
        </div>
        <div class="section-body">
            <ul class="grid">
                <li v-for="(item, index) in vuexCategoryAllList" v-bind:key="index">
                    <div lass="category-item form-check-sq">
                        <input type="radio" :id="`category${item.catId}`" :value="item" v-model="checkedCategory" class="visually-hidden">
                        <label :for="`category${item.catId}`" class="form-check-sq-label">
                            <template v-if="item.isTotalCat === 'Y'">
                                <figure class="i-defalt" :style="`background-image: url(${allCatImgPath})`"></figure>
                                <figure class="i-checked" :style="`background-image: url(${allCatImgPathSub})`"></figure>
                            </template>
                            <template v-else>
                                <figure class="i-defalt" :style="`background-image: url(${item.catImgPath})`"></figure>
                                <figure class="i-checked" :style="`background-image: url(${item.catImgPathSub})`"></figure>
                            </template>
                            <span>{{item.catNm}}</span>
                        </label>
                    </div>
                </li>
            </ul>
        </div>
    </section>
</template>

<script>
import { mapMutations, mapState } from 'vuex';

export default {
    data(){
        return{
            checkedCategory: null,
            allCatImgPath: require('@/assets/img/category/icon_brick.png'),         // 전체 선택 아이콘 이미지 경로
            allCatImgPathSub: require('@/assets/img/category/icon_brick_wht.png'),  // 전체 선택 아이콘 이미지 경로
        }
    },

    computed: {
        ...mapState({
            // userData: state => state.userData,
            // userNo: state => state.userNo,
            vuexCategoryAllList: state => state.exploreProductStore.vuexCategoryAllList,
            initVuexCheckedCategory: state => state.exploreProductStore.initVuexCheckedCategory,
            // vuexCheckedCategory: state => state.exploreProductStore.vuexCheckedCategory,
        }),
    },

    created(){
        this.initChecked();
    },

    watch: {
        // 초기값을 받아오면
        initVuexCheckedCategory(){ 
            this.initChecked();
        },
        // 카테고리 선택값 변화시 
        checkedCategory(){
            if(!this.checkedCategory){
                this.initChecked();
            }else{
                this.setVuexCategorySearchValue(this.checkedCategory);
            }
        },
    },

    methods: {
        ...mapMutations({
            setVuexCategorySearchValue: 'exploreProductStore/setVuexCategorySearchValue',
        }),

        // 초기화 == 전체카테고리 선택 
        initChecked(){
            this.checkedCategory = this.initVuexCheckedCategory;

            // this.checkedCategory = this.vuexCategoryAllList.find((item) => item.isTotalCat === 'Y');
            // this.setVuexCategorySearchValue(this.checkedCategory);
        },

        // // 클릭이벤트 복수선택시 - 전체 카테고리 선택시 처리(v-model 타입이 배열인 경우)
        // detectValue(targetIsTotalCat){
        //     if(targetIsTotalCat === 'Y'){
        //         const onlyAllArr = this.vuexCategoryAllList.filter((item) => item.isTotalCat === 'Y');
        //         this.checkedCategory = onlyAllArr;
        //     }else{
        //         const allIndex = this.checkedCategory.findIndex((item) => item.isTotalCat === 'Y');
        //         if(allIndex !== -1){
        //             this.checkedCategory.splice(allIndex, 1);
        //         }
        //     }
        // },
    },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/search-calculator.scss';

    .grid{
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        // grid-template-columns: repeat(auto-fit, minmax(20%, auto));
        gap: 8px;
        @media (min-width: 768px) {
            grid-template-columns: repeat(5, 1fr);
        }
        @media (min-width: 1200px) {
            grid-template-columns: repeat(10, 1fr);
        }
        @media (max-width: 349px) {
            grid-template-columns: repeat(3, 1fr);
        }
    }
    input {
        &:checked+label.form-check-sq-label,
        &[checked="checked"]+label.form-check-sq-label {
            color: var(--white);
            background: var(--periwinkle);

            svg{
                path{
                    fill: var(--white);
                }

                [fill="black"]{
                    fill: var(--white);
                }

                [stroke="black"]{
                    stroke: var(--white);
                }
            }

            .i-defalt{
                display: none;
            }

            .i-checked{
                display: block;
            }
        }
    }

    .form-check-sq-label{
        cursor: pointer;
        // display: block;
        // width: 72px;
        height: 72px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 8px;
        border-radius: var(--border-radius);
        background: var(--white);
        color: var(--black);
        line-height: 1;
        font-size: 12px;
        font-weight: 500;

        @media (min-width: 768px) {
            font-size: 16px;
            height: 100px;
        }

        svg{
            path{
                fill: var(--black);
            }
        }

        figure{
            width: 37px;
            height: 37px;
            background-repeat: no-repeat;
            background-position: center;
            background-size: 100%;
        }

        .i-defalt{
            display: block;
        }

        .i-checked{
            display: none;
        }
    }
</style>